import { computed } from '@nuxtjs/composition-api'
import { productGetters } from '~/composables/propeller/getters'
import { ProductArg } from '~/types/propeller'

const map: Record<string, string> = {
    EXAMEN_BOLCOM: require('~/assets/img/bol.com.png'),
    EXAMEN_BRUNA: require('~/assets/img/bruna.nl.png'),
    EXAMEN_DIJK: require('~/assets/img/vandijk.nl.png')
}

export function usePartners (product: ProductArg) {
    const partners = computed(() => productGetters.getAttributes(product, Object.keys(map)))

    return computed(() => {
        if (!Array.isArray(partners.value)) {
            return
        }
        return partners.value.map(partner => ({
            ...partner,
            image: map[partner.name]
        }))
    })
}
